export default __webpack_public_path__ + "static/media/logo.53585e2a.svg";